import React from 'react';

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, children, className = '' }) => (
  <div className={`h-full bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-4 flex flex-col ${className}`}>
    <h3 className="text-sm font-medium text-gray-400 mb-3">{title}</h3>
    <div className="flex-1 min-h-0">{children}</div>
  </div>
);

export default ChartCard;
